import { Box, Button, Typography } from "@material-ui/core";
import { NodeModel } from "@minoru/react-dnd-treeview";
import React, { useState } from "react";
import { ErrorModal } from "../../../../../../../../../components/modals/error-modal";
import MesfModal from "../../../../../../../../../components/modals/modal.mesf";
import { ButtonWithLoading } from "../../../../../../../../../components/shared/buttons/button-with-loading";
import { TagFromTree } from "../../../../../models/TagsTree.model";
import {
	deleteTagFolder,
	upsertTagFolder,
} from "../../../../../repository/TrendingRepository";

interface Props {
	open: boolean;
	handleClose: (shouldUpdate: boolean) => void;
	tagNodeSelectedInTree: NodeModel<TagFromTree> | null;
}
export const RemoveFolderModal = ({
	open,
	handleClose,
	tagNodeSelectedInTree,
}: Props) => {
	const [error, setError] = useState<string>("");
	const [isLoading, setIsLoading] = useState<boolean>(false);

	const onSubmit = async (e: any) => {
		e.preventDefault();
		if (tagNodeSelectedInTree) {
			const parentId = Number(tagNodeSelectedInTree?.parent) || null;
			const name = tagNodeSelectedInTree?.text;
			const id = Number(tagNodeSelectedInTree?.id);
			let resp;
			setIsLoading(true);
			if (parentId) {
				resp = await deleteTagFolder(id);
				if (!resp.ok) {
					setError(resp.message);
				}
			} else {
				resp = await upsertTagFolder(id, parentId, name, false);
			}
			if (!resp.ok) {
				setError(resp.message);
			}
		}
		handleClose(true);
		setIsLoading(false);
	};

	return (
		<>
			<MesfModal
				open={open}
				handleClose={() => handleClose(false)}
				maxWidth={"lg"}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
				title="Remove Folder"
			>
				<MesfModal.Content>
					<Box>
						<Typography>
							Are you sure you want to remove{" "}
							<strong>{tagNodeSelectedInTree?.text}</strong> folder?
						</Typography>
					</Box>
				</MesfModal.Content>
				<MesfModal.Actions>
					<div>
						<Button
							color="secondary"
							variant="outlined"
							onClick={() => handleClose(false)}
						>
							Cancel
						</Button>
					</div>
					<div>
						<ButtonWithLoading
							isLoading={isLoading}
							onClick={onSubmit}
							color="primary"
							variant="contained"
						>
							Remove
						</ButtonWithLoading>
					</div>
				</MesfModal.Actions>
			</MesfModal>
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
};
